import React from 'react';
import { Label } from 'reactstrap';
import { useSelector } from 'react-redux';

const Bottom_input = ({ selected_params , onchange_selected_output_param }) => {
    const { params_list } = useSelector((state)=> state.WorkFlowBuilder)
  return (
    <>
    <Label className='cus-font'>Output given to</Label>
        <select onChange={onchange_selected_output_param} className='form-select'>
              <option selected={'next' === selected_params}  value={'next'}>{'next'}</option>
            {
              params_list.map((ele,index)=>{
                return <option selected={ele === selected_params} key={index} value={ele}>{ele}</option>
              })
            }
            
        </select>
    </>
  )
}

export default Bottom_input